import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NitelComponent } from 'src/app/models/nitel-component.model';

@Component({
  selector: 'app-service-billing',
  templateUrl: './service-billing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ServiceBillingComponent {
  @Input() components: NitelComponent[];

  @Input() monthlyTotal: number;
}
